import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import Loader from '../../components/Loader'
import OrgCard from '../../components/OrgCard'
import { useNavigate } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import { FaPlus } from 'react-icons/fa'

//organizations user is admin of

const Admin = () => {
    const [organizations, setOrganizations] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const navigate = useNavigate()


    useEffect(() => {
        const getUserOrgs = async () => {
            try {
                setIsLoading(true)
                const response = await api.get("/organizations/admin")
                if (response) {
                    setIsLoading(false)
                    setOrganizations(response.data)
                }
            } catch (error) {
                setIsLoading(false)
                toast.error(error.response?.data?.message)
            }
        }
        getUserOrgs()
    }, [])
    return (
        <div className='orgpage-body'>
            <h3 className="page-header-title">Administering</h3>

            <div className="org-list-container">
                {isLoading && <Loader />}
                {!isLoading && organizations.length === 0 &&
                    <p className="not-found-msg">You are not an admin of any organizations</p>
                }
                {
                    organizations.map((org) => (
                        <OrgCard org={org} key={org._id} />
                    ))
                }
            </div>
        </div>
    )
}

export default Admin